import React from "react";
import { Box, Card, Divider, Typography, Chip, Stack } from "@mui/material";
import { CheckCircle2, TrendingDown } from "lucide-react";
import styles from "./cisoDashboard.module.scss";

const activity = [
  { label: "Policy Update", time: "2m ago" },
  { label: "User Login", time: "23m ago" },
];

export const ImmutableAuditLog = () => {
  return (
    <Card
      className={styles.card}
      sx={{ borderRadius: 2, width: "100%" }}
      variant="outlined"
      elevation={0}
    >
      <Box className={styles.sectionTitleRow}>
        <Box>
          <Typography className={styles.sectionHeading} fontWeight={700}>
            Immutable Audit Log
          </Typography>
          <Typography className={styles.subtitle}>Blockchain-backed</Typography>
        </Box>
      </Box>
      <Box className={styles.gradientBox}>
        <Typography className={styles.subtitle} color="#ffffff">
          Total Events Logged
        </Typography>
        <Typography variant="h4" fontWeight={800} color="#ffffff">
          847,293
        </Typography>
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          color="#dbeafe"
          mt={0.5}
        >
          <TrendingDown size={16} className={styles.rotate180} />
          <Typography variant="body2">+1,247 today</Typography>
        </Box>
      </Box>
      <Divider sx={{ my: 1.5 }} />
      <Typography fontWeight={700} mb={1}>
        Recent Activity
      </Typography>
      <Box className={styles.list}>
        {activity.map((item) => (
          <Stack
            key={item.label}
            gap={2}
            direction={"row"}
            justifyContent={"space-between"}
          >
            <Stack gap={2} direction={"row"} alignItems="center">
              <Box className={styles.dot} />
              <Box className={styles.listText}>
                <Typography>{item.label}</Typography>
                <Typography className={styles.subtitle}>{item.time}</Typography>
              </Box>
            </Stack>
            <CheckCircle2 size={16} color="#10b981" />
          </Stack>
        ))}
      </Box>
      <Divider sx={{ my: 1.5 }} />
      <Box display="flex" justifyContent="space-between">
        <Typography className={styles.subtitle}>Chain Status</Typography>
        <Chip label="Verified" color="success" size="small" />
      </Box>
      <Box display="flex" justifyContent="space-between" mt={0.5}>
        <Typography className={styles.subtitle}>Last Validation</Typography>
        <Typography fontWeight={600}>1m 42s ago</Typography>
      </Box>
    </Card>
  );
};

export default ImmutableAuditLog;
